import React from 'react';
import './bags.css';

const Bags = () => {
  return (
    <div className='tableWrapper'>
      <p className='p-pos'>No bags available without inserting API KEY</p>
    </div>
  );
};

export default Bags;